import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs'
import { TranslateModule } from '@ngx-translate/core';
import { AngularMaterialModule } from 'angular-material/angular-material.module';

import { FuseSharedModule } from '@fuse/shared.module';
import { HomeComponent } from './home.component';

import { ArtstuffSharedModule } from 'app/shared/shared.module';
import { ArtstuffAclModule } from '@aes/acl';

const routes: Routes = [
    {
        path: 'home',
        component: HomeComponent,
        resolve: {}
    },
];

const COMPONENTS = [
    HomeComponent
];

const ENTRY_COMPONENTS = [];
@NgModule({
    imports: [
        RouterModule.forChild(routes),
        ArtstuffSharedModule,
        TranslateModule,
        AngularMaterialModule,
        FuseSharedModule,
        MatTabsModule,
        ArtstuffAclModule
    ],
    providers: [],
    declarations: [...COMPONENTS, ...ENTRY_COMPONENTS],
    exports: [...COMPONENTS, ...ENTRY_COMPONENTS],
})
export class HomedModule { }
